import React, { useEffect, useId, useState } from "react";
import { FaCamera, FaFilePdf, FaCloudUploadAlt, FaTimes } from "react-icons/fa";

export default function IdentityDocumentUpload({
  file, onChange, onError, onCamera, disabled = false,
  label = "Arquivo do documento", cameraLabel = "Fotografar documento",
}) {
  const id = useId();
  const [url, setUrl] = useState("");
  const [dragging, setDragging] = useState(false);
  const pdf = file && (file.type === "application/pdf" || /\.pdf$/i.test(file.name));
  useEffect(() => {
    if (!file || pdf) { setUrl(""); return; }
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [file, pdf]);
  const select = (files) => {
    if (disabled || !files?.length) return;
    if (files.length > 1) {
      onError("Escolha um arquivo por vez. Para frente e verso juntos, use um PDF de até 2 páginas.");
      return;
    }
    const next = files[0];
    if (next.size > 10 * 1024 * 1024 || !(
      /\.(pdf|jpe?g|png)$/i.test(next.name) ||
      ["application/pdf", "image/jpeg", "image/png"].includes(next.type)
    )) {
      onError("Escolha PDF, JPG ou PNG de até 10 MB.");
      return;
    }
    onError("");
    onChange(next);
  };
  return (
    <div className="signature-document-upload">
      <div className="signature-document-options" data-dragging={dragging}
        onDragOver={(e) => { e.preventDefault(); if (!disabled) setDragging(true); }}
        onDragLeave={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setDragging(false); }}
        onDrop={(e) => { e.preventDefault(); setDragging(false); select(e.dataTransfer.files); }}>
        <label className="signature-document-choice">
          <FaCloudUploadAlt aria-hidden="true" />
          <strong>{file ? "Trocar arquivo" : "Escolher arquivo"}</strong>
          <span>Do celular ou computador</span>
          <input aria-label={label} aria-describedby={`${id}-help`} type="file"
            accept="application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png"
            disabled={disabled} onChange={(e) => { select(e.target.files); e.target.value = ""; }} />
        </label>
        {onCamera && <button type="button" className="signature-document-choice"
          aria-label={cameraLabel} disabled={disabled} onClick={onCamera}>
          <FaCamera aria-hidden="true" /><strong>{cameraLabel}</strong><span>Usar a câmera deste dispositivo</span>
        </button>}
      </div>
      <p id={`${id}-help`} className="signature-help">PDF, JPG ou PNG · até 10 MB · PDF de até 2 páginas. Você também pode arrastar um arquivo para a área acima.</p>
      {file && <figure className="signature-document-selected">
        {pdf ? <FaFilePdf aria-hidden="true" /> : url && <img src={url} alt="Documento selecionado" />}
        <figcaption><strong>{file.name}</strong><span>
          {file.size < 1024 * 1024 ? `${Math.max(1, Math.ceil(file.size / 1024))} KB` : `${(file.size / 1024 / 1024).toFixed(1)} MB`} · pronto para enviar
        </span></figcaption>
        <button type="button" aria-label={"Remover documento"}
          disabled={disabled} onClick={() => onChange(null)}><FaTimes /></button>
      </figure>}
      <div className="signature-document-tips">
        <strong>Antes de enviar</strong>
        <p>Use RG, CIN ou CNH com foto, nome, CPF e data de nascimento legíveis no mesmo arquivo. Se os dados estiverem em lados diferentes, envie frente e verso juntos em um PDF de até 2 páginas.</p>
        <p>Enquadre o documento inteiro, com boa luz e sem reflexos. Confira se os números estão nítidos na prévia.</p>
      </div>
    </div>
  );
}
